
/* Mini Cart
**********************************************************************/

var Cart = {
	
	// Setings
	options : {},
	
	// Cart JSON
	json: {},
	
	// Is minicart on page?
	has_minicart: false,
	
	// Minicart
	minicart: function() {
		return $('#minicart');	
	},
	
	// Get cart items list
	list: function() {
		return $('#minicart .cart-body');
	},

	// Change cart subtotal
	subtotal: function(value) {
		value = Shopify.formatMoney(value, Cart.options.money_format);
		$('#minicart .cart-subtotal span').text(value);
	},
	
	//Change cart items count, automatically show/hide the minicart
	count: function(value) {
		$('#minicart .cart-trigger .count').text(value);
		if(value > 0) {
			$('#minicart').fadeIn();
			$('body').addClass('has-minicart');
		} else {
			$('#minicart').removeClass('open').fadeOut();
			$('body').removeClass('has-minicart');
		}
	},
	
	// Loading animation
	loading: function(mode) {
		if(mode)
			$('#minicart .cart-table').append('<div class="cart-loading">');
		else
			$('#minicart .cart-loading').remove();
	},
	
	// Initialize
	init: function(options) {
		
		this.options = options;
		
		this.template = $($('#minicart-item').html());
		
		this.has_minicart = $('#minicart').length ? true : false;
		
		if(this.has_minicart)
			this.get();
		
		// Add to cart button
		$('#AddToCart').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			Cart.addNew(this);
		});
		
		// Overlay
		this.minicart().find('.cart-overlay').on('click', Cart.close);
		
	},
	
	// Get cart details
	get: function() {
		
		Cart.loading(true);
			
		$.getJSON('/cart.js', function(response) {
			Cart.json = response;
			Cart.refresh();
		});			
		
	},
	
	// Refresh cart details
	refresh: function() {
		
		if(!Cart.has_minicart)
			return;
		
		var json = Cart.json;
		
		Cart.count(json.item_count);
		Cart.subtotal(json.total_price);
		Cart.list().html('');
		
		if(json.items.length) {
			$.each(json.items, function() {
				Cart.product(this);
			});
		} else {
			Cart.list().html('<p>Cart is empty</p>');
		}
		
		Cart.loading(false);
	
	},
	
	// Write item to the cart
	product: function(item) {

		var product = Cart.template.clone();
		
		product.attr('data-id', item.id).attr('data-quantity', item.quantity);
		product.find('.item-link').attr('href', item.url);
		product.find('img').attr('src', Shopify.Image.getSizedImageUrl(item.image, 'small')).attr('alt', item.title);
		product.find('.title').text(item.title);
		product.find('.variant').text(item.variant_title);
		product.find('.price').text(Shopify.formatMoney(item.price * item.quantity, Cart.options.money_format));
		product.find('.quantity').text(item.quantity);
		
		Cart.list().append(product);
		
	},
	
	// Open/Close mini cart
	toggle: function() {
		
		Cart.minicart().toggleClass('open');
		
	},
	
	// Open
	open: function() {
		
		Cart.minicart().addClass('open');
		
	},
	
	// Open
	close: function() {
		
		Cart.minicart().removeClass('open');
		
	},
	
	// Remove all products from the cart
	clear: function() {
		
		Cart.loading(true);
		
		$.post('/cart/clear.js', function(response) {
			Cart.json = response;
			Cart.refresh();
		}, 'json');

	},
	
	// Increment product
	increment: function(el) {

		var product = $(el).parents('.cart-item');
		Cart.loading(true);
		
		$.post('/cart/add.js', {
			id: product.attr('data-id'),
			quantity: 1
		}, function(xhr) {
			Cart.get();	
		}, 'json')
		.fail(function(xhr) {
			// Inventory limit
			Cart.loading(false);
			var response = $.parseJSON(xhr.responseText);
			alert(response.message + "\n" + response.description);
		});
		
	},
	
	// Decrement product
	decrement: function(el) {
		
		var product = $(el).parents('.cart-item');
		Cart.loading(true);
		
		$.post('/cart/change.js', {
			id: product.attr('data-id'),
			quantity: parseInt(product.attr('data-quantity')) - 1
		}, function(response) {
			Cart.json = response;
			Cart.refresh();
		}, 'json');
		
	},
	
	// Bounce effect
	bounce: function() {
		
		var bounce = Cart.minicart().find('.cart-container');
		bounce.removeClass('bounce');
		bounce.outerWidth();
		bounce.addClass('bounce');
		
	},
	
	// Add new product to the cart list
	addNew: function(el) {
		
		var form = $(el).parents('form');

		$.post('/cart/add.js', form.serialize(), function(response) {
			if(response.status && response.status == 422) {
				alert(response.message + "\n" + response.description);
			} else {
				Cart.get();
				if(Cart.json.item_count == 0) {					
					Cart.open();
					setTimeout(function() {
						Cart.close();
					}, 5000);
				}
				Cart.bounce();
			}
		}, 'json');
		
	}

};